var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49634 0H12.5035V3.50753H7.49634V0Z",
    fill: "#5B6673"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9505 17.9917H0.0493164C0.279802 19.1357 1.29251 19.9999 2.50362 19.9999H17.4969C18.7076 19.9999 19.7203 19.1357 19.9505 17.9917Z",
    fill: "#5B6673"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 2.50357C20.0001 1.12293 18.8771 0 17.4968 0H14.9932V4.75235C14.9932 5.43992 14.4357 5.99717 13.7484 5.99717H6.25164C5.56407 5.99717 5.00682 5.43992 5.00682 4.75235V0H2.50357C1.12293 0 0 1.12293 0 2.50357V15.5022H20.0001V2.50357Z",
    fill: "#5B6673"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/product-icon.8447a4368826aba57f0bde13c58ff76d.svg";
export { ForwardRef as ReactComponent };